import { makeApiRequest } from '@/src/lib/api-request'
import { useQuery } from '@tanstack/react-query'
import { useUser } from '@/src/store/user-store'
import { useToken } from '@/src/store/token-store'

interface VerificationStatus {
  bankFailureReason: string
  panFailureReason: string
  bankVerification: string
  panVerification: string
  aadharNumber?: string
  gstNumber?: string
  attemptLeft: string
  aadhaarVerification?: string
  gstVerification?: string
  data?: {
    sessionId: string
    status: string
    name?: string
    pan?: string
    accountNo?: string
    ifsc?: string
    aadhaarNumber?: string
    gstNumber?: string
  }
}

export const useVerificationStatusQuery = () => {
  const { user, _hasHydrated } = useUser()
  const { accessToken } = useToken()
  return useQuery({
    queryKey: ['verification-status'],
    queryFn: async () => {
      const response = await makeApiRequest({
        method: 'GET',
        url: '/Earning/getVerificationStatus',
        isAuthenticated: true,
        data: {},
        fallbackError: 'Error while fetching verification status',
        isV3Api: true,
      })

      if (response.response.length === 0) {
        return {
          bankFailureReason: '',
          panFailureReason: '',
          bankVerification: 'pending',
          panVerification: 'pending',
          attemptLeft: '3',
        } as VerificationStatus
      }

      return response.response[0] as VerificationStatus
    },
    enabled: !!_hasHydrated && !!accessToken,
    refetchInterval: (query) =>
      query.state.data?.data?.status === 'processing' ? 5000 : false,
    refetchOnWindowFocus: false,
  })
}
